import {
  USER_SAVE,
  USER_LOGIN,
  USER_LOGOUT,
  USER_PAY,
  SET_EVENT,
  SET_PARTICIPANT,
  UPDATE_TICKET,
  SET_RESERVATIONS_ROOMS,
  SET_REGISTER_USER,
  SET_PARTICIPANT_EVENT_DATA,
  SET_EVENTID,
  SET_PROGRAM,
  SET_STATUS,
  SET_BILLING_DATA,
  SET_COURSES,
  USER_COMPLETE_REGISTER_CARD,
  SET_BOOKINGS,
  SET_BILLINGS,
} from "./mutation-types";
import User from "@/models/user";
import { BillingParticipant } from "@/vue-core/models/Billing.model";

export default {
  [USER_SAVE](state: any, data: any) {
    state.data.uid = data.uid;
    state.data.email = data.email;
    state.data.photoURL = data.photoURL;
    state.data.displayName = data.displayName ? data.displayName : data.email;
    state.data.userClaims = data.userClaims;
    state.data.emailVerified = data.emailVerified;
  },
  [USER_LOGIN](state: any, value) {
    state.logged = value;
  },
  [SET_BILLING_DATA](state: any, data: BillingParticipant) {
    state.billingData = data;
  },
  [SET_REGISTER_USER](state: any, value) {
    state.completeRegister = value;
  },
  [SET_EVENTID](state: any, value) {
    state.currentEventID = value;
  },
  // General info of Participant
  [SET_PARTICIPANT](state: any, data) {
    state.participantGeneralData = data;
  },
  // Info of participant by event
  [SET_PARTICIPANT_EVENT_DATA](state: any, data) {
    state.participantData = data;
  },
  [SET_EVENT](state: any, eventData) {
    state.eventData = eventData;
  },
  [USER_LOGOUT](state: any) {
    state.data = {};
    state.participantData = null;
    state.participantGeneralData = null;
    state.completeRegister = false;
    state.activateCardRegister = false;
    window.localStorage.clear();
    state.logged = false;
    User.getLoginForm().email.value = "";
    User.getLoginForm().password.value = "";
  },
  [UPDATE_TICKET](state: any, ticketType) {
    state.participantData.ticketType = ticketType;
  },
  [SET_RESERVATIONS_ROOMS](state: any, rooms) {
    state.reservationRooms = rooms;
  },
  [USER_PAY](state: any, value) {
    state.statusPaid = value;
  },
  [SET_PROGRAM](state: any, program) {
    state.program = program;
  },
  [SET_STATUS](state: any, status) {
    state.status = status;
  },
  [SET_COURSES](state: any, courses) {
    state.courses = courses;
  },
  [USER_COMPLETE_REGISTER_CARD](state: any, status) {
    state.activateCardRegister = status;
  },
  [SET_BOOKINGS](state: any, bookings) {
    state.bookings = bookings;
  },
  [SET_BILLINGS](state: any, billings) {
    state.billings = billings;
  },
};
